import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    products: "Products",
    categories: "Categories",
    home: "Home",
    address: "Mansoura- ",
    telephone: "0502390014",
    phone: "+201000121882",
    whatsapp: "+201062697722",
    categoriesTitle: "Categories",
    productsTitle1: "Our",
    productsTitle2: "Products",
    noProducts: "No Products",
    noCategories: "There is No Category matches this name",
    search: "Search for a Product",
    searchMsg: "?What are you searching for",
    searchBtn: "Search",
    description: ":Description",
    height: "Length",
    depth: "Width",
    material: "Material",
    price: "Price",
    category: "Category",
    header: "!Welcome to AlFursan",
    minPrice: "From",
    maxPrice: "To",
    style: "Style",
    execute: "Executed or not",
    executeInput: "Choose your preferences",
    sort: "Sort by",
    chooseSort: "Choose a sorting method",
    earliest: "Oldest",
    newest: "Newest",
    priceAsc: "Price (Asc)",
    priceDesc: "Price (Desc)",
    who: "?Who are we",
    about1: "People love with their eyes",
    about2:
      "At AlFursan, we firmly believe in the magic of visual appeal. As experts in crafting captivating gypsum products, we're dedicated to making a lasting impression. With cutting-edge technology and skilled artisans, we bring your vision to life with precision and careful attention to detail. From intricate designs to stunning patterns, our top-notch quality consistently goes beyond what you'd expect. Whether it's a home project or a business venture, we're committed to delivering excellence in every way.",
    about3:
      "At AlFursan, we invite you to experience the beauty and versatility of gypsum. Explore our gallery and witness how we can transform your space into a genuine work of art.",
    services: "Our Services",
    service1: "Exclusive Designs",
    service1details:
      "Discover our collection of 6000 unique designs, meticulously crafted to suit your individual style and preferences.",
    service2: "Premium Quality Materials",
    service2details:
      "Experience uncompromising quality with our designs, made using only the finest materials for long-lasting durability.",
    service3: "Worldwide Shipping",
    service3details:
      "No matter where you are, we offer reliable worldwide shipping, ensuring your order reaches you conveniently and securely.",
    service4: "Exceptional Value",
    service4details:
      "Get the most value for your investment with our competitive prices and exceptional designs that exceed your expectations.",
    service5: "Bring Your Vision to Life with 3D Design",
    service5details:
      "Let your imagination soar as our skilled team brings your vision to life with our cutting-edge 3D design capabilities.",
    service6: "Secure Packaging",
    service6details:
      "We take great pride in providing secure and stylish packaging that ensures your order arrives in pristine condition.",
    notFound: "This Page is not Found",
    seeMore: "See More",
    materialInput: "Select a material",
    styleInput: "Select a style",
    filterHeader: "Apply filters",
    commonQuestionsTitle: "Common Question",
    commonQuestions:
      "What is the difference between gypsum plaster and polyurethane?",
    answerIntro:
      "Gypsum plaster has always been a common method for decorating rooms throughout history. Its use as a decorative material has a long history, even in ancient times. It was used to adorn temples, palaces, living spaces, and more. Modern gypsum plaster is made from various materials, with the most popular and practical being natural gypsum and polyurethane.",
    detailsBtn: "Show Details",
    q1: "In terms of aesthetic performance",
    q1Answer:
      "Polyurethane-based Vituk moldings are known to be popular in the market, and it is easy to assemble shapes made from this material, with low weight and cost. On the other hand, gypsum is the market leader due to its intricate artistic and technical properties, including:",
    q1AnswerList1:
      "Gypsum molds, crafted by our company's employees, provide an opportunity to create exclusive interior designs that emphasize the uniqueness of room design.",
    q1AnswerList2:
      "With gypsum, you can create almost any shape and pattern, which cannot be said for Vituk. Through Vituk, you can obtain standardized products at prices without indulging in a special design and model vision.",
    q2: "In terms of cost",
    q2Answer:
      "Polyurethane-based Vituk molding is known for its low cost, which contributes to its popularity in the market. Vituk (polyurethane) is cheaper, but when you use gypsum as a decoration, it provides unique design aesthetics, individuality to your decor, natural quality, and a longer lifespan that you cannot achieve with Vituk. Opting for gypsum decor is not unconventional, and it does not require additional financial investments, and it will last with you for many years.",
    q3: "In terms of reliability and durability",
    q3Answer:
      "After analyzing the functional characteristics of gypsum and Vituk (polyurethane), we can conclude that gypsum is the material that can be described as more durable and reliable based on the following:",
    q3AnswerList1:
      "Gypsum molding provides a secure and guaranteed fill, with no gaps or cracks, significantly extending the product's lifespan. Unlike Vituk, which cannot have its mold joints repaired.",
    q3AnswerList2:
      "With gypsum, you can create gypsum molds can be shaped to fit any surface without gaps this material is known for its flexibility. Vituk is not flexible; it has a fixed bending that cannot be altered.",
    q3AnswerList3:
      "Gypsum does not shrink under any external conditions, maintaining its original shape, size, and composition.",
    q3AnswerList4:
      "Under certain conditions, Vituk may lose its attractive appearance and experience cracks during sudden temperature changes in the room.",
    q3AnswerList5:
      "Gypsum is non-flammable, safe for human health, and not susceptible to moisture. Vituk material is used in rooms with low temperatures where a stable temperature is maintained.",
    q3AnswerList6:
      "Gypsum does not turn yellow it remains white for many years, which cannot be said for Vituk (polyurethane).",
    q3AnswerList7:
      "Gypsum is a natural material that does not emit toxins and does not cause allergies, unlike Vituk (polyurethane), which is not entirely safe as it is of synthetic origin.",
    relatedProducts: "Related Products",
    currencyLabel: ":Display products using this currency",
    EGP: "EGP",
    USD: "USD",
    offer: "Offer",
    cm: "cm",
    language: "Ar",
  },
  ar: {
    products: "المنتجات",
    categories: "الأقسام",
    home: "الرئيسية",
    address: "المنصورة -حي الأشجار أمام ابن سينا للأدوية",
    telephone: "٠٥٠٢٣٩٠٠١٤",
    phone: "٢٠١٠٠٠١٢١٨٨٢+",
    whatsapp: "٢٠١٠٦٢٦٩٧٧٢٢+",
    categoriesTitle: "أقسامنا",
    productsTitle1: "ألقِ نظرة على",
    productsTitle2: "منتجاتنا",
    noProducts: "لا منتجات للعرض",
    noCategories: "لا يوجد قسم بهذا الاسم",
    search: "ابحث عن منتج",
    searchMsg: "ما هو اسم المنتج الذي تبحث عنه؟",
    searchBtn: "بحث",
    description: "وصف المنتج:",
    height: "الطول",
    depth: "العرض",
    material: "المادة الخام",
    price: "السعر",
    category: "القسم",
    header: "في الفرسان ستجد كل ما هو جديد",
    minPrice: "من",
    maxPrice: "إلى",
    material: "المادة الخام",
    style: "الستايل",
    execute: "تم تنفيذه من قبل أم لا",
    executeInput: "قم باختيار ما تفضله",
    sort: "رتّب حسب:",
    chooseSort: "اختر طريقة للترتيب",
    earliest: "الأقدم",
    newest: "الأحدث",
    priceAsc: "السعر (تصاعدي)",
    priceDesc: "السعر (تنازلي)",
    who: "من نحن؟",
    about1: "بالعين، يجد الناس متعة التفاصيل",
    about2:
      "ففي الفرسان، إيمان راسخ بسحر جاذبية العنصر البصري. كخبراء في صناعة منتجات الجص المبهرة، نكرس أنفسنا لترك أثر لا يُنسى. مع تقنية متقدمة وحرفيين ماهرين، نحيي رؤيتك بدقة فائقة وعناية شديدة للتفاصيل. من التصاميم المعقدة إلى الأنماط الرائعة، جودتنا المتميزة تتجاوز توقعاتك بلا تردد. سواء كان المشروع منزليًا أو تجاريًا، نلتزم بتقديم التفوق في كل جانب.",
    about3:
      "في الفرسان، ندعوك لتجربة جمال وتعددية الجبس. استكشف معرضنا وكن شاهدًا على كيفية تحويل مساحتك إلى عمل فني حقيقي.",
    services: "خدماتنا",
    service1: "تصميمات حصرية",
    service1details:
      "اكتشف مجموعتنا من 6000 تصميم فريد، صُنع بعناية فائقة ليلائم أسلوبك الشخصي وتفضيلاتك.",
    service2: "مواد عالية الجودة",
    service2details:
      "استمتع بجودة لا مثيل لها مع تصاميمنا، حيث يتم صنعها باستخدام أجود المواد لضمان المتانة والاستدامة على المدى الطويل.",
    service3: "شحن لجميع انحاء العالم",
    service3details:
      "مهما يكون مكانك، نقدم خدمة شحن عالمية موثوقة، مضمونة لضمان وصول طلبك بسهولة وبأمان.",
    service4: "قيمة استثنائية",
    service4details:
      "احصل على أقصى قيمة مع أسعارنا التنافسية وتصاميمنا الاستثنائية التي تتجاوز توقعاتك.",
    service5: "تحقيق رؤيتك من خلال التصميم ثلاثي الأبعاد",
    service5details:
      "دع خيالك يطير بينما يحقق فريقنا الماهر رؤيتك من خلال قدراتنا المتقدمة في التصميم ثلاثي الأبعاد.",
    service6: "تغليف آمن",
    service6details:
      "نحن نفخر بتوفير تغليف آمن وأنيق يضمن وصول طلبك بحالة ممتازة.",
    notFound: "هذه الصفحة غير موجودة",
    seeMore: "عرض المزيد",
    materialInput: "اختر المادة الخام",
    styleInput: "اختير الستايل",
    filterHeader: "هل تبحث عن مواصفات معينة؟",
    commonQuestionsTitle: "من الأسئلة الشائعة",
    commonQuestions: "ما الفرق بين الجبس البلدي والفيوتك (البولي يوريثين)؟",
    q1: "من حيث الآداء الجمالي",
    q1Answer:
      "يُعرف قولبة الفيوتك المصنوعة من مادة (البولي يورثين) انها تحظي بشعبية في السوق، وإنه من السهل تجميع الاشكال المصنوعة من هذه المادة ولها وزن وسعر منخفض. أما الجبس فهو الرائد في السوق بسبب خصائصه الفنية والجمالية المعقدة ومن هذه الخصائص :",
    q1AnswerList1:
      "أنه تعتبر قوالب الجبس ، التي يصنعها موظفوا شركتنا فرصة لإنشاء تصميم داخلي حصري نأكد به على تفردفي تصميم الغرفة.",
    q1AnswerList2:
      "من الجبس  يمكنك إنشاء أي شكل واي نمط تقريبًا وهو أمر لا يمكن قوله عن الفيوتك. من خلال الفيوتك يمكنك الحصول على المنتجات القياسية في الاسعار دون تلذذ ورؤية خاصة بالتصميم والموديل.",
    q2: "من حيث التكلفة",
    q2Answer:
      "يُعرف قولبة الفيوتك المصنوعة من مادة (البولي يوريثين) بتكلفتها المنخفضة، وبفضلها تحظى بشعبية في السوق، الفيوتك (البولي يوريثين) أرخص لكن مع استخادمك للجبس كديكور توفر على جماليات خاصة بالتصميم وتفرد الديكور الخاص بك وجودة طبيعية وطول عمر لا يمكنك الحصول عليه مع الفيوتك ،الخضوع لديكور الجبس ليس غريب الأطوار ، ولا يتطلب استثمارات مالية إضافية وسوف يستمر معك لسنوات عديدة",
    q3: "من حيث الموثوقية والمتانة",
    q3Answer:
      "بعد تحليل السمات الوظيفية للجبس والفيوتك (البولي يوريثين) ، يمكننا أن نستنتج أن الجبس هو الذي يمكن وصفه بأنه مادة أكثر متانة وموثوقية بناء علي ما يلي:",
    q3AnswerList1:
      "قولبة الجبس  حشو مضمون لا تتباعد مفاصل الجبس ولا تتشقق فهذا يطيل بشكل كبير من عمر المنتج. على عكس الفيوتك التي لا يمكن إصلاح وصلات قولبتة.",
    q3AnswerList2:
      "بمساعدة الجبس يمكنك إنشاء قوالب الجبس التي يمكن تثبيتها على أي سطح دون وجود فجوات. الفيوتك ليس مرنًا ، فهذه المادة لها ثني مصنع معين لا يمكن تغييره.",
    q3AnswerList3:
      "الجبس لا يتقلص تحت أي ظروف خارجية ، تحتفظ المادة بشكلها الأصلي وحجمها وتكوينها التثبيت أيضًا لا يضر بالجبس.",
    q3AnswerList4:
      "في ظل ظروف معينة ، يفقد الفيوتك مظهره الجذاب ، ويمكن تغطيته بالشقوق أثناء التغيرات المفاجئة في درجة الحرارة في الغرفة. يمكن أن يتسبب الفيوتك في إتلاف السحابات.",
    q3AnswerList5:
      "الجبس غير قابل للاحتراق  آمن لصحة الإنسان غير قابل للرطوبة يتم تركيب مادة الفيوتك في غرفة درجة حرارتها منخفضة حيث يتم ضمان درجة حرارة ثابتة.",
    q3AnswerList6:
      "الجبس لا يتحول إلى اللون الأصفر يبقى لون الثلج الأبيض لسنوات عديدة ، وهو ما لا يمكن قوله عن الفيوتك (البولي يوريثين).",
    q3AnswerList7:
      "الجبس مادة طبيعية لا تنبعث منها سموم ولا تسبب الحساسية علي عكس الفيوتك (البولي يوريثين) الذي لا يعد آمن تمامًا ، لأنه من أصل صناعي.",
    answerIntro:
      "لطالما كان الجبس طريقة شائعة لتزيين الغرف في جميع الأوقات، استخدام هذا الديكور له تاريخ طويل حتى في العصور القديمة، كان يستخدم لتزيين المعابد والقصور وأماكن المعيشة والجبس الحديث مصنوع من مواد مختلفة  أكثرها شعبية وعملية هي الجبس الطبيعي والفيوتك (البولي يوريثين). ",
    detailsBtn: "عرض التفاصيل",
    relatedProducts: "منتجات مشابهة",
    currencyLabel: "عرض المنتجات بعملة:",
    offer: "خصم",
    EGP: "جنيه مصري",
    USD: "دولار",
    cm: "سم",
    language: "En",
  },
};

const storedLocale = localStorage.getItem("lang");
const defaultLocale = storedLocale || "ar";

const i18n = new VueI18n({
  locale: defaultLocale,
  messages,
});

export default i18n;
